import React from "react";
import CarItemForm from "./CarItemForm";
import {
    useFetchCarsWithSeason,
} from "../../../features/season/seasonApi";
import {SeasonModel} from "../../../features/season/seasonTypes";

type Props = {
    season: SeasonModel,
    selectedCarId: number | 0,
    setSelectedCarId: (id: number | 0) => void

}

const CarListForm = ({season,selectedCarId,setSelectedCarId }: Props) => {
    const seasonID = season.id
    const {data: cars} = useFetchCarsWithSeason(seasonID, 'cars');

    if (!cars || !cars) {

        return <></>
    }
    return (

        <>
            {cars?.map((car) => (
                <CarItemForm key={car.id} car={car} selectedCarId={selectedCarId} setSelectedCarId={setSelectedCarId} />
            ))}
        </>
    )
}

export default CarListForm;
